import { computed, defineComponent, ref } from "vue";
import { definePropType } from "@types-vue/props";
import LanguageSelector from "@com/components/language-selector/index.vue";
export default defineComponent({
    components: {
        LanguageSelector: LanguageSelector
    },
    props: {
        sourceLanguageLists: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        targetLanguageLists: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        sourceLanguage: String,
        targetLanguage: String,
        disabledSelect: {
            type: Boolean,
            default: false
        },
        disabledSelectByEditMode: {
            type: Boolean,
            default: false
        },
        pureTranslation: {
            type: Boolean,
            default: false
        },
        // 自定义常用语言
        commonLanguages: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        // 项目来源
        type: {
            type: String,
            default: ""
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var langSelectForm = ref(null);
        var sourceLanguageModel = computed({
            get: function() {
                return props.sourceLanguage;
            },
            set: function(value) {
                emit("update:sourceLanguage", value);
            }
        });
        var targetLanguageModel = computed({
            get: function() {
                return props.targetLanguage;
            },
            set: function(value) {
                emit("update:targetLanguage", value);
            }
        });
        var handleMouseEnter = function() {
            emit("handleMouseEnter");
        };
        var formData = computed({
            get: function() {
                return {
                    select: props.targetLanguage
                };
            },
            set: function(value) {
                console.log("formData.value", value);
            }
        });
        var validate = function(cb) {
            return langSelectForm.value.validate(cb);
        };
        var clearValidate = function() {
            return langSelectForm.value.clearValidate();
        };
        // @ts-ignore
        window.langSelectForm = langSelectForm;
        return {
            sourceLanguageModel: sourceLanguageModel,
            targetLanguageModel: targetLanguageModel,
            handleMouseEnter: handleMouseEnter,
            formData: formData,
            validate: validate,
            langSelectForm: langSelectForm,
            clearValidate: clearValidate
        };
    }
});
